




























































































import { Vue, Component, Prop, p } from "av-ts";
import { ILocalisedEvent, IRecommendedRole } from "../../interfaces/models";
import { timeToAMPM } from "../../util.ts";
import RoleChip from "../peers/RoleChip.vue";

@Component({
    components: {
        RoleChip
    }
})
export default class TimelineEvent extends Vue {
    @Prop event = p<ILocalisedEvent>({
        required: true
    });

    cancelEvent() {
        this.$emit("change", this.event.id);
    }

    get time() {
        if (this.event) {
            return timeToAMPM(new Date(this.event.date));
        } else {
            return "";
        }
    }

    get user() {
        if (this.event) {
            return this.event.user;
        } else {
            return "";
        }
    }

    get userRoles(): IRecommendedRole[] {
        if (this.event) {
            return this.event.recommendedRole;
        } else {
            return [];
        }
    }

    get location() {
        return this.event ? this.event.location : "";
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/TimelineEvent.vue